import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddReservationPage } from '../add-reservation/add-reservation.page';
import { GlobalVariable } from '../global';
import { ReservationDetailsPage } from '../reservation-details/reservation-details.page';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.page.html',
  styleUrls: ['./reservations.page.scss'],
})
export class ReservationsPage implements OnInit {
pastReservations=[];
dataLoading=true;
  constructor(private modalCtrl:ModalController,private server:UserApiService,public globals:GlobalVariable) { }

  ngOnInit() {
    this.getReservations()
  }
  async addNew(){
    let modal=await this.modalCtrl.create({
      component:AddReservationPage,
      mode:'ios',
      cssClass:'reserveModal'
    })
    modal.present();
    modal.onDidDismiss().then(res=>{
      console.log(res);
      if(res.data){
        this.getReservations();
      }
    })

  }
  getReservations(){
    this.dataLoading=true;
    this.server.getReservations().subscribe(res=>{
      console.log(res)
      this.dataLoading=false;
      if(res.success){
        this.pastReservations=res.data
      }
    },err=>{
      this.globals.presentToast('Network Error')
      this.dataLoading=false;
    })

  }
  async openDetails(item){

    let modal=await this.modalCtrl.create({
      component:ReservationDetailsPage,
      componentProps:{item:item},
      mode:'ios',
      // cssClass:'reserveModal',
      breakpoints:[0,1],
      initialBreakpoint:1,
    })
    modal.present()

  }
}
